import AxiosMockAdapter from 'axios-mock-adapter';
import {fastapi} from 'api';

const axiosFastMockAdapter = new AxiosMockAdapter(fastapi, {delayResponse: 1000});

export default axiosFastMockAdapter;
